export const instantRipsSounds = {
    boxOpen: { src: '/audio/01_BOX_OPEN.mp3' },
    boxReveal: { src: '/audio/01_BOX_REVEAL.mp3' },

    cardStaticState: { src: '/audio/03_CARD_STATIC_STATE.mp3', loop: true, volume: 0.4 },
    cardInfoReveal: { src: '/audio/09_INSERT_CARD_REVEAL.mp3' },
    nextPrev: { src: '/audio/07_NEXT_PREV.mp3' },
    fadeAway: { src: '/audio/08_FINAL_CARD_FADEAWAY.mp3' },

    teamInfoReveal: { src: '/audio/10_TEAM_META_DATA_REVEAL.mp3' },
    playerInfoReveal: { src: '/audio/11_TEAM_META_DATA_REVEAL.mp3' },
    lightsDownReveal: { src: '/audio/12_LIGHTS_DOWN_REVEAL.mp3' },

    heartbeat: { src: '/audio/13_HEARTBEAT.mp3' },

    goldenTicketAmbient: { src: '/audio/instant-rips/gt-ambient.mp3', loop: true, volume: 0.3 },
    goldenTicketReveal: { src: '/audio/instant-rips/gt-reveal.mp3' },
    goldenTicketShing: { src: '/audio/instant-rips/gt-shing.mp3' },
};
